import React from 'react';

interface InputProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'dangerouslySetInnerHTML'
  > {
  className?: string;
}

const TextField: React.FC<InputProps> = ({ ...rest }: any, className) => {
  return (
    <input
      className={`border rounded-lg border-shadow-3 px-2 py-[2px] text-contentMobile text-[12 px] w-full h-[45px] focus:outline-black ${className}`}
      {...rest}
    />
  );
};

export default TextField;
